import { Injectable } from '@angular/core';
import { finalize } from 'rxjs/operators';
import { TitleService } from './title.service';
import { PacienteServiceProxy } from '@shared/service-proxies/service-proxies';

@Injectable()
export class PacienteService {
  private readonly IdKey = 'id';
  private readonly IsProfissionalKey = 'medico';

  constructor(
    private _titleService: TitleService,
    private _pacienteService: PacienteServiceProxy,
  ) {
    const storedId = localStorage.getItem(this.IdKey);
    if (storedId) {
      this.id = storedId;
    }

    const storedIsProfissional = localStorage.getItem(this.IsProfissionalKey);
    if (storedId) {
      this.id = storedId;
    }
  }

  private _id: string = '';
  private _isProfissional: boolean = false;

  get id(): string {
    return this._id;
  }

  set id(value: string) {
    this._id = value;
    localStorage.setItem(this.IdKey, value);
  }

  clearId(): void {
    this._id = '';
    localStorage.removeItem(this.IdKey);
  }

  getId(): string {
    if (!this._id) {
      const storedId = localStorage.getItem(this.IdKey);
      if (storedId) {
        this._id = storedId;
      } else {
        return null;
      }
    }
    return this._id;
  }

  get isProfissional(): boolean {
    return this._isProfissional;
  }

  set isProfissional(value: boolean) {
    this._isProfissional = value;
    localStorage.setItem(this.IsProfissionalKey, value ? "true" : "false");
  }

  clearIsProfissional(): void {
    this._isProfissional = false;
    localStorage.removeItem(this.IsProfissionalKey);
  }

  getIsProfissional(): boolean {
    if (!this._isProfissional) {
      const stored_isProfissional = localStorage.getItem(this.IsProfissionalKey);
      if (stored_isProfissional) {
        this._isProfissional = stored_isProfissional.toLowerCase() == "true" ? true : false;
      } else {
        return null;
      }
    }
    return this._isProfissional;
  }

  setTitleGrafico(pacienteId, nomeTela:string) {
    abp.ui.setBusy();
    this._pacienteService.getNomePaciente(pacienteId).pipe(
      finalize(() => {
        abp.ui.clearBusy();
      })
    ).subscribe((nome) => {
      this._titleService.setTitleObs(`${nomeTela} - ${nome}`)
    })
  }
}
